export default "__VITE_ASSET__CwhM8hxR__"